import { IAnnouncement } from '@connec10/media-interface/src/entity'
import {
  GetAnnouncementRequest,
  GetAnnouncementResponse,
  ListAnnouncementsRequest,
  ListAnnouncementsResponse
} from '@connec10/media-interface/src/request'
import useSWR from 'swr'
import { axios } from '../../libs'
import { SWRCachePath } from '../swr-cache-path'

export const useGetListAnnouncement = ({ page = 1, perPage = 12 }: ListAnnouncementsRequest['query']) => {
  const { data, error } = useSWR<ListAnnouncementsResponse>(SWRCachePath.getListAnnouncement({ page, perPage }), () => {
    return axios.get<ListAnnouncementsResponse>(`/announcements?page=${page}&perPage=${perPage}`).then(res => res.data)
  })
  return {
    listAnnouncement: data?.announcements,
    pagination: data?.pagination,
    error,
    isLoading: !data && !error
  }
}

export const useGetAnnouncement = ({ announcementId }: GetAnnouncementRequest['param']) => {
  const { data, error } = useSWR<IAnnouncement>(SWRCachePath.getAnnouncement({ announcementId }), () => {
    return axios
      .get<GetAnnouncementResponse>(`/announcements/${announcementId}`)
      .then<IAnnouncement>(res => res.data.announcement)
  })
  return {
    announcement: data,
    error,
    isLoading: !data && !error
  }
}
